let ingredients, ingredientsImage
window.addEventListener('DOMContentLoaded', (event) => {
    ingredients = document.querySelector(".ingredients");
    ingredientsImage = document.querySelector(".ingredients-image");
    if (isMobile) {
        if (ingredientsImage != null && ingredients != null) {
            if (ingredientsImage.complete && ingredientsImage.naturalHeight !== 0) {
                ingredientsEqualizeHeights()
            } else {
                ingredientsImage.addEventListener('load', ingredientsEqualizeHeights);
                ingredientsImage.addEventListener('error', () => alert('error'));
            }
        }
    }
});

window.addEventListener('resize', ingredientsEqualizeHeights);


function isMobile() {
    if (window.outerWidth < 750) { return true; } else { return false; }
}

function ingredientsEqualizeHeights() {
    let heightToMatch = ingredientsImage.offsetHeight;
    ingredients.style.height = heightToMatch + "px";
}
